<template>
<div class="mAboutAgency">
    <NoData v-if="!item.withinfo.withwe"></NoData>
    <div v-else class="desc" v-html="item.withinfo.withwe"></div>
</div>
</template>

<script>
import $ from 'jquery'
import NoData from 'views/mobile/components/noData/noData'
export default {
    name: 'mAboutAgency',
    props: ['item'],
    data() {
        return {
            images: [],
            startPosition: 1
        }
    },
    mounted() {
        let _this = this
        this.$nextTick(() => {
            let imgs = $('.mAboutAgency img')
            for (let i = 0; i < imgs.length; i++) {
                this.images.push(imgs[i].getAttribute('src'))
            }
            $('.mAboutAgency').on('click', 'img', function () {
                let url = this.getAttribute('src')
                let index = 1
                _this.images.forEach((obj, index) => {
                    if (obj == url) {
                        _this.startPosition = index
                    }
                })
                _this.fullImage(index)
            })
        })
    },
    methods: {
        fullImage(index) {
            this.$imagePreview({
                images: this.images,
                startPosition: index
            });
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
      NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mAboutAgency {
    color: $c-black;
    /*min-height: calc(100vh - 4.1rem);*/
    min-height: calc(100vh - 0.8rem);
    background: $c-white;
    padding-top:0.32rem;
    padding-bottom: 0.5rem;
    .desc{
        margin: 0 0.32rem;
        font-size: 0.26rem;
        line-height: 0.4rem;
        img, video{
            margin: 0.2rem 0;
            width: 100%;
            height: auto;
        }
        p{
            margin-bottom: 0.2rem;
        }
    }
    img{
        width: 2rem;
        height: 2rem;
    }
}
</style>